import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Utilities.frontend.types'

@Injectable({ providedIn: 'root' })
export class Utilities_reserve_batchId_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { entity: string, batchSize: number }): Promise<{ newIdCeiling?: number, reasons?: string[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.entity)) {
      $missingRequiredInParams.push('\'entity\'');
    }
    if (isNil($inParams.batchSize)) {
      $missingRequiredInParams.push('\'batchSize\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

